export default "__VITE_ASSET__D5NYp_VP__"